"use client";

import { useEffect, useRef, useState } from "react";

import styles from "./StripTextUI.module.scss";

const StripTextUI = ({ text, speed = 2 }) => {
  const marqueeRef = useRef(null);
  const containerRef = useRef(null);
  const requestRef = useRef(null);
  const posX = useRef(0);
  const isUsedOnce = useRef(false);


  const initAnimation = ({ container,  marquee }) => {

    const animate = () => {

      posX.current -= speed;

      if ( posX.current < -marquee.offsetWidth ) {
        posX.current = container.offsetWidth;
      }

      marquee.style.transform = `translateX(${posX.current}px)`;
      requestRef.current = requestAnimationFrame(animate);
    };

    requestRef.current = requestAnimationFrame(animate);

    return () => cancelAnimationFrame(requestRef.current);
  }


  useEffect(() => {

    if(!isUsedOnce.current){

      const container = containerRef.current;
      const marquee = marqueeRef.current;

      initAnimation({ container, marquee });

      isUsedOnce.current = true
    }
  
  }, []);


  const stopMarquee = () =>{
    cancelAnimationFrame(requestRef.current);
  }

  const restartMarquee = () => {
    const container = containerRef.current;
    const marquee = marqueeRef.current;
    
    initAnimation({ container, marquee });
  }

  return (
    <div
      ref={containerRef}
      className={styles.stripContainer}
      onMouseEnter={stopMarquee}
      onMouseLeave={restartMarquee}
    >
      <div
        ref={marqueeRef}
        style={{
          position: "absolute",
          willChange: "transform",
          paddingBottom: 4,
        }}
        dangerouslySetInnerHTML={{ __html: text }}
      ></div>
    </div>
  );
};

export default StripTextUI;
